module.exports = __webpack_public_path__ + "static/media/youtube.96065583.svg";